import { VehicleService } from "../../../service/vehicle-service";

export const fetchModelImg = (modelId, params) => () => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchModelImg(modelId, params).then(response => {
            resolve(response.data.detail && response.data.detail.modelImageUrl);
        }).catch(error => {
            reject(error);
        });
    });
};

export const getQuestionForUserIntent = () => () => {
    return new Promise((resolve, reject) => {
        VehicleService.getQuestionForUserIntent("pdi_buyer").then(response => {
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};
